import { render, staticRenderFns } from "./hazardDetail.vue?vue&type=template&id=7f18faab&"
import script from "./hazardDetail.vue?vue&type=script&lang=js&"
export * from "./hazardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports